module.exports = __webpack_public_path__ + "img/catch-thief-bg.be89b09a.svg";